import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyTracker from 'shared/ahoy_tracker';

export default class SubscriptionBanner {
  static show() {
    if (SubscriptionBanner.isBlockingBannerExist()) {
      return;
    }
    let premiumBanner = document.querySelector('.js-watchpage-premium-banner');
    let premiumSubscribeBanner = document.querySelector('.b-premium-subscribe-banner');

    if(premiumBanner !== null){
      SubscriptionBanner.changePremierTitleWhenInsufficientPackage();
      premiumBanner.classList.remove('hide');
      SubscriptionBanner.sendImpression(premiumBanner);
    }

    if(premiumSubscribeBanner !== null){
      SubscriptionBanner.changePremierTitleWhenInsufficientPackage();
      premiumSubscribeBanner.classList.remove('hide');
    }
  }
  static hide() {
    let premiumBanner = document.querySelector('.js-watchpage-premium-banner');
    if(premiumBanner) {
      premiumBanner.classList.add('hide');
    }

    let premiumSubscribeBanner = document.querySelector('.b-premium-subscribe-banner');
    if(premiumSubscribeBanner) {
      premiumSubscribeBanner.classList.add('hide');
    }
  }

  static changePremierTitleWhenInsufficientPackage() {
    if(!VidioHelpers.isPremiumUser()) {
      return;
    }

    let defaultPremiumBannerTitle = document.querySelector('.js-watchpage-premium-banner-title.banner--default');
    let mismatchPremiumBannerTitle = document.querySelector('.js-watchpage-premium-banner-title.banner--mismatch');

    if (defaultPremiumBannerTitle) {
      defaultPremiumBannerTitle.classList.add('hide');
    }

    if (mismatchPremiumBannerTitle) {
      mismatchPremiumBannerTitle.classList.remove('hide');
    }
  }

  static sendImpression(element) {
    window.dataLayer.push({
      event: 'impression',
      feature_name: element.dataset.gtmName,
      feature_location: element.dataset.gtmLoc,
      feature_type: element.dataset.gtmType
    });
    SubscriptionBanner.ahoyTracker(element).sendEvent();
  }

  static ahoyTracker(element) {
    return new AhoyTracker(element);
  }

  static isBlockingBannerExist() {
    return document.querySelectorAll('.livestreaming__blocking-banner-container').length > 0;
  }
}
